import JobBrowsingView from './jobBrowsing/view/JobBrowsing';

export default JobBrowsingView;
